// extracted by mini-css-extract-plugin
export default {"edgebutton":"style_edgebutton__p3Pt0","edgebuttonforeignobject":"style_edgebuttonforeignobject__ctSR9"};